module.exports = __webpack_public_path__ + "img/dropdown-side-arr-icon.20f5e3d1.svg";